import { cva, type VariantProps } from 'class-variance-authority';

const baseClassName = [
  'flex',
  'justify-center',
  'items-center',
  'cursor-pointer',
  'rounded-sm',
  'duration-250',
  'group-[.drawer]/modal:right-9',
  'group-[.drawer]/modal:top-8',
  'transform-gpu',
  'transition-all',
  'duration-250',
  'ease-in-out',
];

export const buttonNavigationVariants = cva(baseClassName, {
  variants: {
    variant: {
      outline: [
        'border',
        'hover:bg-stone-100',
        'active:bg-stone-200',
        'disabled:text-stone-400',
        'disabled:border-stone-400',
        'disabled:pointer-events-none',
      ],
      text: [
        'hover:border',
        'hover:border-stone-300',
        'hover:bg-stone-200',
        'active:bg-stone-200',
        'active:border',
        'active:border-stone-400',
        'disabled:text-stone-400',
        'disabled:pointer-events-none',
      ],
    },
    color: {
      primary: ['text-stone-900', 'border-stone-900'],
      secondary: ['text-greyscale-600', 'border-greyscale-600'],
      menu: [
        'opacity-0',
        'hover:opacity-100',
        'hover:bg-stone-800',
        'hover:text-greyscale-50',
        'active:bg-stone-900',
        'active:text-greyscale-50',
      ],
      danger: [
        'text-red-500',
        'border-red-600',
        'hover:border-red-600',
        'active:border-red-600',
        'hover:bg-red-50',
        'active:bg-red-100',
      ],
    },
    size: {
      default: ['w-[32px]', 'h-[32px]'],
      small: ['w-[24px]', 'h-[24px]'],
    },
  },
  defaultVariants: {
    variant: 'outline',
    color: 'primary',
    size: 'default',
  },
});

export type ButtonNavigationVariants = VariantProps<
  typeof buttonNavigationVariants
>;
